import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";

const ModalExample = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    repos,
    changeStagingprj,
    setRepo
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("Select source code staging project names:");
  const [warningText, setWarningText] = useState("Exception");

  const toggle = () => setModal(!modal);

  const close = ()=>{
    toggle();
    changeStagingprj()
  }


  useEffect(() => {

  }, []);

  return (

    <i>
      <Button className="button asse_upload" style={{backgroundColor:"#5e7a2b", marginBottom:'10px'}} onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className} >
        {hasTitle && (
          <ModalHeader toggle={toggle}>
            {(info || confirmation) &&(<div style={{width: "450px"}}><img alt="SHIFT" src={infoLogo} className={"modal_logo"}/><i>{infoText}</i> </div>)}
            {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className={"modal_logo"}/>{warningText} </div>)}
          </ModalHeader>
        )}
        <ModalBody>
          {repos.map((item,i) => (
            <div key={i}>
              <input type="checkbox" checked={item.checked} key={i} onChange={()=>{item.checked = !item.checked; setRepo(repos)}} />{' '}
              {item.value}
            </div>
          ))}

        </ModalBody>
        <ModalFooter>
          {(info || warning) &&(
            <button
              className="button"
              style={{ marginLeft : "auto", marginRight : "auto"}}
              type="button"
              onClick={close}
            >
              <FormattedMessage id="nav.ok" defaultMessage="OK" />
            </button>
          )}
        </ModalFooter>
      </Modal>
    </i>
  );
}

export default ModalExample;



// WEBPACK FOOTER //
// ./src/components/views/ProjectManagement/popup.js